import SectionUnit from '../api/sectionUnit';
import { applicationDestroy } from './applicationActions';

export const destroySectionUnit = applicationDestroy(SectionUnit);
